import _classCallCheck from "/home/runner/work/coqui-ai.github.io/coqui-ai.github.io/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/coqui-ai.github.io/coqui-ai.github.io/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { getOriginalFunction } from '@sentry/utils';
var originalFunctionToString;
/** Patch toString calls to return proper name for wrapped functions */

var FunctionToString = /*#__PURE__*/function () {
  function FunctionToString() {
    _classCallCheck(this, FunctionToString);

    FunctionToString.prototype.__init.call(this);
  }
  /**
   * @inheritDoc
   */


  _createClass(FunctionToString, [{
    key: "__init",
    value:
    /**
     * @inheritDoc
     */
    function __init() {
      this.name = FunctionToString.id;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "setupOnce",
    value: function setupOnce() {
      originalFunctionToString = Function.prototype.toString;

      Function.prototype.toString = function () {
        var context = getOriginalFunction(this) || this;

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return originalFunctionToString.apply(context, args);
      };
    }
  }], [{
    key: "__initStatic",
    value: function __initStatic() {
      this.id = 'FunctionToString';
    }
  }]);

  return FunctionToString;
}();

FunctionToString.__initStatic();

export { FunctionToString };